import Vue from "vue";
import VueCarousel from 'vue-carousel';
import Splide from '@splidejs/splide';
import VueMaterialTabs from "vue-material-tabs";
import VueCollapse from 'vue2-collapse';
import configuratorStore from "./stores/configuratorStore";
import Vuex from "vuex";
import vSelect from 'vue-select';
import CookieBanner from "./components/CookieBanner.vue";
import HeaderSection from "./components/HeaderSection.vue";
import ProductConfigurator from "./components/ProductConfigurator.vue";
import FooterSection from "./components/FooterSection.vue";
import TextSection from "./components/TextSection.vue";
import DetailsSection from "./components/DetailsSection.vue";
import DocumentSection from "./components/DocumentSection.vue";
import FeatureMatrixTable from "./components/FeatureMatrixTable.vue";
import ReviewSection from "./components/ReviewSection.vue";
import BenefitSection from "./components/BenefitSection.vue";
import FAQSection from "./components/FAQSection.vue";
import MoodSection from "./components/MoodSection.vue";
import AppSection from "./components/AppSection.vue";

Vue.use(Vuex);
Vue.use(VueCarousel);
Vue.use(VueCollapse);
Vue.use(VueMaterialTabs);

Vue.component('cookie-banner', CookieBanner);
Vue.component('headerSection', HeaderSection);
Vue.component('productConfigurator', ProductConfigurator);
Vue.component('footerSection', FooterSection);
Vue.component('textSection', TextSection);
Vue.component('detailsSection', DetailsSection);
Vue.component('documentSection', DocumentSection);
Vue.component('feature-matrix-table', FeatureMatrixTable);
Vue.component('reviewSection', ReviewSection);
Vue.component('benefitSection', BenefitSection);
Vue.component('faqSection', FAQSection);
Vue.component('moodSection', MoodSection);
Vue.component('app-section', AppSection);
Vue.component('v-select', vSelect);

if (document.getElementById("newLanding")) {
    new Vue({
        el: '#newLanding',
        store: configuratorStore,
    });
}

document.addEventListener("DOMContentLoaded", function () {
    let splideDesktop = new Splide('#image-slider-desktop', {
        pagination: false,
        perPage: 4,
        rewind: true,
        perMove: 1,
        gap: 20,
        width: 1300,
    }).mount();

    let splideLengthDesktop = document.getElementById('splide-length-desktop');
    let splideIndexDesktop = document.getElementById('splide-index-desktop');

    splideLengthDesktop.innerHTML = splideDesktop.length;
    splideIndexDesktop.innerHTML = splideDesktop.index + 1;

    splideDesktop.on('active', function () {
        splideIndexDesktop.innerHTML = splideDesktop.index + 1;
    });
    /* mobile */
    let splideMobile = new Splide('#image-slider-mob', {
        pagination: false,
        padding: {right: '30%'},
        gap: 5,
    }).mount();

    let splideLengthMob = document.getElementById('splide-length-mob');
    let splideIndexMob = document.getElementById('splide-index-mob');

    splideLengthMob.innerHTML = splideMobile.length;
    splideIndexMob.innerHTML = splideMobile.index + 1;

    splideMobile.on('active', function () {
        splideIndexMob.innerHTML = splideMobile.index + 1;
    });
});

document.addEventListener("DOMContentLoaded", function () {
    /* moodDesktop */
    let elms = document.getElementsByClassName('moodSplide');
    let splideLengthMood = document.getElementsByClassName('mood-length-desktop');
    let splideIndexMood = document.getElementsByClassName('mood-index-desktop');

    for (let i = 0; i < elms.length; i++) {
        var splideMood = new Splide(elms[i], {
            pagination: false,
            padding: {right: '30%'},
            rewind: true,
            perMove: 1,
            gap: 50,
            width: 900,
        }).mount();
        splideLengthMood[i].innerHTML = splideMood.length;
        splideIndexMood[i].innerHTML = splideMood.index + 1;
        splideMood.on('active', function () {
            splideIndexMood[i].innerHTML = splideMood.index + 1;
        });
    }

    /* moodMobile */
    let elmsMob = document.getElementsByClassName('mobileMoodSplide');
    let splideLengthMoodMob = document.getElementsByClassName('mood-length-mob');
    let splideIndexMoodMob = document.getElementsByClassName('mood-index-mob');

    for (let i = 0; i < elmsMob.length; i++) {
        let splideMoodMobile = new Splide(elmsMob[i], {
            pagination: false,
            gap: 10,
            padding: {right: '14%'}
        }).mount();

        splideLengthMoodMob[i].innerHTML = splideMoodMobile.length;
        splideIndexMoodMob[i].innerHTML = splideMoodMobile.index + 1;

        splideMoodMobile.on('active', function () {
            splideIndexMoodMob[i].innerHTML = splideMoodMobile.index + 1;
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    /* reviewDesktop */
    let splideReviewDesktop = new Splide('#review-desktop', {
        pagination: false,
        perPage: 3,
        rewind: true,
        perMove: 1,
        gap: 50,
        width: 1300,
    }).mount();

    let splideLengthReviewDesktop = document.getElementById('review-length-desktop');
    let splideIndexReviewDesktop = document.getElementById('review-index-desktop');

    splideLengthReviewDesktop.innerHTML = splideReviewDesktop.length;
    splideIndexReviewDesktop.innerHTML = splideReviewDesktop.index + 1;

    splideReviewDesktop.on('active', function () {
        splideIndexReviewDesktop.innerHTML = splideReviewDesktop.index + 1;
    });
    /* reviewMobile */
    let splideReviewMobile = new Splide('#review-slider-mob', {
        pagination: false,
        padding: {right: '10%'},
        gap: 10,
    }).mount();

    let splideLengthReviewMob = document.getElementById('review-length-mob');
    let splideIndexReviewMob = document.getElementById('review-index-mob');

    splideLengthReviewMob.innerHTML = splideReviewMobile.length;
    splideIndexReviewMob.innerHTML = splideReviewMobile.index + 1;

    splideReviewMobile.on('active', function () {
        splideIndexReviewMob.innerHTML = splideReviewMobile.index + 1;
    });
});
